import cmsInstance from 'shared/services/cms';

// Type for allowed emails
export type AllowedDeleteUserEmail = string;

/**
 * Fetch allowed emails for delete user functionality from server
 * @returns Promise<string[]>
 */
export const fetchAllowedDeleteUserEmails = async (): Promise<string[]> => {
  try {
    const { data } = await cmsInstance.get<string[]>(
      '/v2/data-store/emails_admin'
    );
    return data;
  } catch (error) {
    console.error('Error fetching allowed emails:', error);
    // Fallback to empty array if server fails
    return [];
  }
};

/**
 * Check if an email is allowed (e.g. para borrar usuarios u otras acciones restringidas)
 * @param email - Email to check
 * @param allowedEmails - Array of allowed emails
 * @returns boolean
 */
export const isEmailAllowed = (
  email: string,
  allowedEmails: string[]
): email is AllowedDeleteUserEmail => {
  return allowedEmails.includes(email);
};
